module.exports = __webpack_public_path__ + "media/images/country_flags/aw-72734f927f8cc9521c8bc36bc997a2b2.png";